import { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { translateStatesfalabbela } from "../../utils/objects/translateStates";
import { pdf } from "@react-pdf/renderer";
import { generateBarcodeBase64 } from "../DocumentoPDFShippingLabelPrint/generateBarcodeBase64.js";
import { generateQRBase64 } from "../DocumentoPDFShippingLabelPrint/generateQRBase64.js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DocumentoPDFShippingLabelPrintBicci from "../DocumentoPDFShippingLabelPrint/DocumentoPDFShippingLabelPrintBicci.jsx";
import { useNavigate } from "react-router-dom";
import { customLocaleText } from "../../utils/objects/CustomLocaleTextTables.jsx";
import DispatchQuickView from "../Dispatchdetails/DispatchQuickView.jsx";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const DataGridoOders = ({
  dataOrdesRequets,
  UpdateOrderForAcctions,
  updateOrderStatusInMerge,
  firebaseUser,
}) => {
  const navigate = useNavigate();
  const [columns, setColum] = useState([]);
  const [seletedOrders, setSelectedOrders] = useState([]);
  const [quickOpen, setQuickOpen] = useState(false);
  const [quickRow, setQuickRow] = useState(null);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (dataOrdesRequets) {
      upDateTable(dataOrdesRequets);
    }
  }, [dataOrdesRequets]);

  const handleSelectionChange = (selection) => {
    setSelectedOrders(selection);

    const normalizeID = (id) => (String(id).startsWith("F") ? id : "F" + id);

    const formattedIds = selection.map(normalizeID);

    UpdateOrderForAcctions(formattedIds);
  };

  const handlePrint = async (order) => {
    let orderSelect = dataOrdesRequets.filter((item) => item.id === order.id);

    const barcodeImage = await generateBarcodeBase64(orderSelect[0].id);

    const barcodeImageLpn = orderSelect[0].soc
      ? await generateBarcodeBase64(orderSelect[0].soc)
      : "";

    const QRImage = await generateQRBase64(orderSelect[0].id);

    const blob = await pdf(
      <DocumentoPDFShippingLabelPrintBicci
        order={orderSelect[0]}
        barcodeImage={barcodeImage}
        barcodeImageLpn={barcodeImageLpn}
        qrImage={QRImage}
      />
    ).toBlob();

    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  const handleEdithNavigateRows = (dataRow) => {
    const url = `/dashboard/dispatch/edithDetails/F${dataRow.id}`;
    window.open(url, "_blank");
  };

  const handleNavigateRows = (dataRow) => {
    const url = `/dashboard/dispatch/details/F${dataRow.id}`;
    window.open(url, "_blank");
  };

  const upDateTable = () => {
    const renderPiking = (params) => {
      if (params.row.isPickedUp === true) {
        return <CheckCircleIcon sx={{ color: "#4FFF33" }}></CheckCircleIcon>;
      } else {
        return (
          <ReportGmailerrorredIcon
            sx={{ color: "#D80B0B" }}
          ></ReportGmailerrorredIcon>
        );
      }
    };

    const columnsTable = [
      {
        field: "id",
        headerName: "ID",
        width: 150,
      },
      {
        field: "placeName",
        headerName: "ORIGEN",
        width: 150,
      },
      {
        field: "driverName",
        headerName: "RIDER",
        width: 150,
      },
      {
        field: "createdAt",
        headerName: "CREADO",
        width: 200,
      },
      {
        field: "toAddress",
        headerName: "DESTINO",
        width: 200,
      },
      {
        field: "isPickedUp",
        headerName: "PICKING",
        width: 20,
        renderCell: renderPiking,
        sortable: true,
        filterable: true,
      },
      {
        field: "driverLicensePlate",
        headerName: "RUTA",
        width: 100,
      },
      {
        field: "status",
        headerName: "ESTADO",
        width: 100,
      },
      {
        field: "actions",
        headerName: "ACCIONES",
        width: 200,
        renderCell: renderActionButtons,
      },
    ];

    setColum(columnsTable);

    const tsToStr = (ts) => {
      if (!ts) return null;
      if (typeof ts?.toDate === "function") return ts.toDate().toLocaleString();
      const s = ts?.seconds ?? ts?._seconds;
      return typeof s === "number" ? new Date(s * 1000).toLocaleString() : null;
    };

    const latlngToStr = (p) => {
      if (!p) return null;
      const lat = p.lat ?? p._lat ?? null;
      const lng = p.lng ?? p._long ?? p._lng ?? null;
      return lat != null && lng != null ? `${lat}, ${lng}` : null;
    };

    const rows = (dataOrdesRequets || []).map((o) => ({
      // --- DATOS (generales)
      id: o.id,
      companyID: o.companyID ?? "",
      status: translateStatesfalabbela[o.falabella_status] ?? "",
      statusFalabella: translateStatesfalabbela[o.falabella_status], // legible
      deliveryType: o.deliveryType ?? "",
      tag: o.tag ?? "",
      createdAt: tsToStr(o.createdAt || o.date),
      updatedAt: tsToStr(o.updatedAt),
      placeName: o.placeName ?? "",
      fromAddress: o.fromAddress ?? "",
      fromLatLng: latlngToStr(o.fromAddressLocation),
      amount: o.amount ?? 0,
      serviceAmount: o.serviceAmount ?? 0,
      deliveryAmount: o.deliveryAmount ?? 0,
      driverAmount: o.driverAmount ?? 0,
      totalAmount: o.totalAmount ?? 0,
      express: !!o.express,
      lastMile: !!o.lastMile,

      // --- CLIENTE
      userName: o.userName ?? "",
      userPhone: o.userPhone ?? "",
      userEmail: o.userEmail ?? "",
      userID: o.userID ?? "",
      userDniReceptor: o.userDniReceptor ?? "",
      userNameReceptor: o.userNameReceptor ?? "",
      observationReceptor: o.observationReceptor ?? "",

      // --- OPERACIONALES / DRIVER
      driverID: o.driverID ?? "",
      driverName: o.driverName ?? "",
      driverPhone: o.driverPhone ?? "",
      driverLicensePlate: o.driverLicensePlate ?? "",
      driverLatLng: latlngToStr(o.driverLocation),
      isPickedUp: !!o.isPickedUp,

      // --- ENTREGA
      toAddress: o.toAddress ?? `${o.address ?? ""} ${o.commune2 ?? ""}`.trim(),
      toLatLng: latlngToStr(o.toAddressLocation),
      picsTaken: !!o.picsTaken,
      signTaken: !!o.signTaken,
      picsCount: Array.isArray(o.pics) ? o.pics.length : 0,
      pics: o.pics || [],
      signUrl: o.sign ?? "",
    }));
    setRows(rows);
  };

  const renderActionButtons = (params) => {
    if (params.row.id !== undefined && params.row.id !== "") {
      return (
        <Box
          sx={{
            display: "flex", // Arrange the buttons in a row
            flexDirection: "row",
            justifyContent: "space-between", // Ensure there's space between buttons
            gap: "8px", // Add some space between buttons
          }}
        >
          <IconButton
            sx={{
              width: "30px !important",
              color: "#1e2158 !important",
            }}
            aria-label="Etiqueta"
            onClick={() => handlePrint(params.row)}
          >
            <QrCode2Icon />
          </IconButton>

          <IconButton
            sx={{
              width: "30px !important",
              color: "#1e2158 !important",
            }}
            aria-label="ver"
            onClick={() => handleNavigateRows(params.row)}
          >
            <VisibilityIcon />
          </IconButton>

          <IconButton
            sx={{
              width: "30px !important",
              color: "#1e2158 !important",
            }}
            aria-label="Editar"
            onClick={() => handleEdithNavigateRows(params.row)}
          >
            <ModeEditIcon />
          </IconButton>
          <IconButton
            sx={{
              width: "30px !important",
              color: "#1e2158 !important",
              backgroundColor: "#d1eaff !important",
            }}
            aria-label="soporte"
            onClick={() => {
              setQuickRow(params.row); // ← guardar la fila activa
              setQuickOpen(true); // ← abrir un único modal
            }}
          >
            <SupportAgentIcon />
          </IconButton>
        </Box>
      );
    }
  };

  const getDaysSince = (timestamp) => {
    const seconds = timestamp?.seconds ?? timestamp?._seconds ?? null;

    if (!seconds) return null;

    const created = seconds * 1000;
    const now = Date.now();

    return Math.floor((now - created) / (1000 * 60 * 60 * 24));
  };

  const getRowColorClass = (params) => {
    try {
      const order = dataOrdesRequets.find((o) => o.id === params.id);
      if (!order?.createdAt?._seconds) {
        return "";
      }

      const days = getDaysSince(order.createdAt);
      if (!order.falabella_status) return "row-sytem-error";

      const isDelivered =
        order.status === 8 ||
        order.status === "99" ||
        order.falabella_status === "99";

      const isCancel =
        order.falabella_status === "1029" ||
        order.falabella_status === "1041" ||
        order.falabella_status === "1008" ||
        order.falabella_status === "1002" ||
        order.falabella_status === "1022" ||
        order.falabella_status === "1023" ||
        order.falabella_status === "1019" ||
        order.falabella_status === "1018" ||
        order.falabella_status === "1046";
      if (isCancel) return "row-red";
      if (isDelivered) return "row-green-1";
      if (days > 5) return "row-red";
      if (days >= 1 && days <= 5) return `row-orange-${days}`;
      return ""; // sin color
    } catch (error) {
      console.error("Error al obtener la clase de color de la fila:", error);
      return "";
    }
  };

  return (
    <>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={1000}
        rowsPerPage={[50, 100, 1000]}
        pagination
        localeText={customLocaleText}
        slots={{
          toolbar: GridToolbar, // Incluye la barra de herramientas para opciones adicionales
        }}
        groupingModel={["driverName"]}
        checkboxSelection
        onRowSelectionModelChange={handleSelectionChange}
        getRowClassName={getRowColorClass}
        renderActionButtons={renderActionButtons}
      ></DataGrid>

      <DispatchQuickView
        open={quickOpen}
        onClose={() => setQuickOpen(false)}
        order={quickRow}
        onCrearTicket={(o) => {
          /* tu lógica */
        }}
        onCorregirDatos={(o) => {
          if (quickRow) handleEdithNavigateRows(quickRow);
          setQuickOpen(false);
        }}
        onEnviarExcepcion={(order, payload) => {
          console.log("Actualizar estado de la orden:", order.id, "a", payload);
          // payload.status es el nuevo código (p.ej. "1061", "99", etc.)
          if (payload?.status) {
            updateOrderStatusInMerge(order.id, payload);
          }
        }}
        onLiberarConductor={(o) => {
          console.log("Liberar conductor");
        }}
        onAbrirDetalle={(o) => {
          if (quickRow) handleNavigateRows(quickRow);
          setQuickOpen(false);
        }}
        firebaseUser={firebaseUser}
      />
    </>
  );
};

export default DataGridoOders;
